export default __webpack_public_path__ + "static/media/facebook (1).dbcea355.svg";